import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=0fc77f77&scoped=true"
import script from "./page2.vue?vue&type=script&lang=js"
export * from "./page2.vue?vue&type=script&lang=js"
import style0 from "./page2.vue?vue&type=style&index=0&id=0fc77f77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc77f77",
  null
  
)

export default component.exports